<template>
  <div class="table_wrap">
    <span class="total_length">총 {{ paginationData.total }}개 </span>
    <el-table :data="boardData"
              class="list-table"
              header-cell-class-name="list-header"
              empty-text="데이터가 없습니다."
              height="695"
    >
      <el-table-column
          class="table_no"
          type="index"
          label="No"
          width="90"
          class-name="num text-center"
          :index="tableIdx"
      >
      </el-table-column>
      <el-table-column min-width="200" label="아이디" prop="Writer.mb_id" class-name="text-center"></el-table-column>
      <el-table-column min-width="100" label="이름" prop="Writer.mb_name" class-name="text-center"></el-table-column>
      <el-table-column min-width="350" label="제목" prop="wr_subject" class-name="text-center"></el-table-column>
      <el-table-column label="작성일" width="150" class-name="text-center">
        <template slot-scope="scope">
                    <span>
                        {{scope.row.created_at}}
                    </span>
        </template>
      </el-table-column>
      <el-table-column min-width="155" label="답변상태" prop="wr_subject" class-name="text-center">

        <template slot-scope="scope">
          <span v-html="returnStatus(scope.row.Comment)"></span>
        </template>

      </el-table-column>

      <el-table-column label="상세" width="90" class-name="text-center">
        <template slot-scope="scope">
          <div class="row-info">
            <el-button class="com_btn" @click="goDetail(scope.row.wr_id)">
              상세
            </el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import util from "@/mixins/util";
import memberUtil from "@/components/member/memberUtil";
import dateMixins from "@/mixins/dateMixins";
export default {
  name: "BoardListQnaLayout",
  mixins: [memberUtil,dateMixins],
  components: {},
  inject: {
    setPage: {
      default: () => {
      }
    },
    boardListSetData: {
      default: () => {
      }
    },
    setFilter: {
      default: () => {
      }
    },
  },
  provide() {
    return {}
  },
  props: {
    boardType: '',
    boardData: {
      default: () => {
        return []
      }
    },
    paginationData: {
      default: () => {
        return {total: 0, page: 0, size: 0,}
      }
    },
  },
  data() {
    return {}
  },
  created() {
  },
  mounted() {
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  computed: {},
  methods: {
    goDetail(key) {
      this.$router.push(`/qna/${key}`)
    },
    returnStatus(Comment){
      return !util.isEmpty(Comment.List) ? `<span class="qna_done">완료</span>` : '대기'
    },
    tableIdx(index) {
      return this.paginationData.total - index - (this.paginationData.page - 1) * this.paginationData.size;
    },
  },
  watch: {},
}
</script>

<style scoped>

</style>
